import React, { Component } from 'react';
import _ from 'lodash';
var Api = require('./Config');

export default class JourneyMaster extends Component {
  constructor(props) {
    super(props);
    this.state = { showDetail: false };
    this.state.journeys = [];
  }

  componentDidMount() {
    Api.getJourneyMaster(Api.EXCLUDED_JIDS)
      .then((masters) => {
        this.setState({ journeys: masters });
      })
      .catch((err) => {});
  }

  onClose() {
    this.setState({ showDetail: false });
  }

  render() {
    return (
      <div>
        <div>
          <b>Journeys Available</b>
        </div>
        <div className="row">
          <div className="col-md-6">
            <input type="text" className="form-control" placeholder="search" />
          </div>
        </div>

        <div style={{ marginTop: 10, maxHeight: 400, overflow: 'auto' }}>
          <table className="table table-stripped">
            <tbody>
              {_.map(this.state.journeys, (a, index) => {
                return (
                  <tr key={index}>
                    <td>{a.journey_name}</td>
                    <td>
                      <button
                        onClick={() => {
                          this.getDetailForJourney(a);
                        }}
                        className="btn btn-default"
                      >
                        Detail
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {this.state.showDetail && this.getDetail()}
      </div>
    );
  }

  getDetailForJourney(journey) {
    Api.getMessagesForAJourney(journey.JID)
      .then((messages) => {
        this.setState({ messages: messages, showDetail: true, currentJourney: journey });
      })
      .catch((err) => {});
  }

  getDetail() {
    var items = this.state.messages;
    //messaage_send_day,message_text,response_page_url,resend_delay_day

    return (
      <div className="modal show">
        <div className="modal-dialog  modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                onClick={() => {
                  this.onClose();
                }}
                className="close"
                data-dismiss="modal"
              >
                &times;
              </button>
              <h4 className="modal-title">Journey items for {this.state.currentJourney.journey_name}</h4>
            </div>
            <div className="modal-body">
              <div style={{ marginTop: 10, maxHeight: 400, overflow: 'auto' }}>
                <table className="table table-stripped">
                  <thead>
                    <tr>
                      <th>Send day</th>
                      <th>text</th>
                      <th>url</th>
                      <th>delay days</th>
                    </tr>
                  </thead>
                  <tbody>
                    {_.map(items, (a, index) => {
                      return (
                        <tr key={index}>
                          <td> {a.messaage_send_day}</td>
                          <td>{a.message_text}</td>
                          <td>{a.response_page_url}</td>
                          <td>{a.resend_delay_day}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                onClick={() => {
                  this.onClose();
                }}
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
